import { render } from "./TypeText.vue?vue&type=template&id=5efbd4f6&scoped=true&ts=true"
import script from "./TypeText.vue?vue&type=script&lang=ts"
export * from "./TypeText.vue?vue&type=script&lang=ts"

import "./TypeText.vue?vue&type=style&index=0&id=5efbd4f6&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efbd4f6"]])

export default __exports__